import type { TranslationFunction } from "@home-finance-manager/shared"
import {
  createCreateExpenseValidator,
  createUpdateExpenseValidator,
} from "@home-finance-manager/shared/validators/expenses.validator.factory"
import { z } from "zod"

const splitPreferenceField = z.object({
  splitPreference: z.enum(["equitable", "equal", "custom"]),
})

// Use factory functions with pass-through translation for base schemas
const createExpenseValidatorBase = createCreateExpenseValidator((key: string) => key)
const updateExpenseValidatorBase = createUpdateExpenseValidator((key: string) => key)

export const createExpenseSchemaBase = createExpenseValidatorBase.and(splitPreferenceField)

export const updateExpenseSchemaBase = updateExpenseValidatorBase.and(splitPreferenceField)

/**
 * Create translated expense validation schemas
 * @param t - Translation function
 */
export const createTranslatedExpenseSchemas = (t: TranslationFunction) => {
  // Use factory functions from shared package
  const CreateExpenseValidatorTranslated = createCreateExpenseValidator(t)
  const UpdateExpenseValidatorTranslated = createUpdateExpenseValidator(t)

  const splitPreferenceFieldTranslated = z.object({
    splitPreference: z.enum(["equitable", "equal", "custom"]),
  })

  const createExpenseSchemaTranslated = CreateExpenseValidatorTranslated.and(
    splitPreferenceFieldTranslated
  )
  const updateExpenseSchemaTranslated = UpdateExpenseValidatorTranslated.and(
    splitPreferenceFieldTranslated
  )

  return {
    createExpenseSchema: createExpenseSchemaTranslated,
    updateExpenseSchema: updateExpenseSchemaTranslated,
  }
}

export const createExpenseSchema = createExpenseSchemaBase
export const updateExpenseSchema = updateExpenseSchemaBase

export type CreateExpenseFormData = z.input<typeof createExpenseSchemaBase> & {
  amount: number
}
export type UpdateExpenseFormData = z.input<typeof updateExpenseSchemaBase> & {
  amount: number
}

// Union type for form data (used when we don't know if creating or updating)
export type ExpenseFormData = CreateExpenseFormData | UpdateExpenseFormData
